import { useNavigate } from "react-router-dom";
import { Button } from "@boundary/components/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@boundary/components/dialog";
import { AlertCircle, MapPin } from "lucide-react";
import { prefetchAndNavigate } from "@boundary/utils/prefetchRoute";
import styles from "./ResourcesInsufficientModal.module.scss";

interface ResourcesInsufficientModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  missingResources: string[];
  resourcesDetails: string;
  machineId: number;
}

/**
 * Попап для уведомления о недостаточности ресурсов на аппарате
 */
export function ResourcesInsufficientModal({
  open,
  onOpenChange,
  missingResources,
  resourcesDetails,
  machineId,
}: ResourcesInsufficientModalProps) {
  const navigate = useNavigate();

  const handleGoToMap = () => {
    onOpenChange(false);
    prefetchAndNavigate(navigate, `/map?machineId=${machineId}`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={styles.dialogContent}>
        <DialogHeader>
          <div className={styles.header}>
            <AlertCircle className={styles.icon} />
            <DialogTitle className={styles.title}>
              Заказ слишком большой для аппарата
            </DialogTitle>
          </div>
          <DialogDescription className={styles.description}>
            К сожалению, данный аппарат не может выполнить ваш заказ в данный момент.
            {resourcesDetails && (
              <p className={styles.descriptionDetails}>
                {resourcesDetails}
              </p>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className={styles.content}>
          {/* Кнопка "Изменить количество" - пока не реализована, но оставляем для будущего */}
          <Button
            variant="secondary"
            className={styles.button}
            disabled
            onClick={() => {
              // TODO: Реализовать автоматическое изменение количества под максимально возможное
              // Пока кнопка неактивна, так как функционал еще не реализован
            }}
          >
            Изменить количество под максимально возможное
            <span className={styles.buttonText}>
              (скоро)
            </span>
          </Button>

          {/* Кнопка "На карту" */}
          <Button
            variant="default"
            className={styles.button}
            onClick={handleGoToMap}
          >
            <MapPin className={styles.buttonIcon} />
            На карту
          </Button>
          <p className={styles.footerText}>
            Или можете выбрать другой аппарат для заказа
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

